import { Link } from "react-router-dom";

const ABOUT_IMG =
  "https://images.pexels.com/photos/34321004/pexels-photo-34321004.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16">
        <div className="grid md:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <div className="label-tracked text-[#C27A62] mb-4">Sobre GALOLÀ</div>
            <h1 className="font-serif-editorial text-5xl md:text-6xl leading-[1.05] text-[#1E1E1E]">
              Hecho a mano, con calma, con cariño.
            </h1>
            <p className="text-[#5C5C5C] mt-8 leading-relaxed">
              GALOLÀ nace del deseo de crear piezas que duren. Empecé en una mesa
              pequeña, con materiales nobles y mucho tiempo por delante. Hoy, cada
              bolso, cada prenda, cada accesorio sigue saliendo de mis manos —pieza
              por pieza— pensados para personas que valoran lo distinto.
            </p>
            <p className="text-[#5C5C5C] mt-4 leading-relaxed">
              No hay producción en serie. No hay prisas. Cada diseño se piensa, se
              prueba y se ajusta hasta que vale la pena.
            </p>
          </div>
          <div className="aspect-[4/5] overflow-hidden bg-[#EDE8DD]">
            <img
              src={ABOUT_IMG}
              alt="Sobre GALOLÀ"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      <section className="bg-[#FAF9F5] border-y border-[#E5E0D8]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-10 py-20">
          <div className="grid md:grid-cols-3 gap-10">
            <div>
              <div className="font-serif-editorial text-4xl text-[#C27A62] mb-3">01</div>
              <h3 className="font-serif-editorial text-2xl mb-2">Diseño propio</h3>
              <p className="text-[#5C5C5C] leading-relaxed">
                Cada modelo se dibuja a mano antes de cortar la primera tela.
              </p>
            </div>
            <div>
              <div className="font-serif-editorial text-4xl text-[#C27A62] mb-3">02</div>
              <h3 className="font-serif-editorial text-2xl mb-2">Materiales nobles</h3>
              <p className="text-[#5C5C5C] leading-relaxed">
                Lino, cuero curtido al vegetal, algodón orgánico, plata reciclada.
              </p>
            </div>
            <div>
              <div className="font-serif-editorial text-4xl text-[#C27A62] mb-3">03</div>
              <h3 className="font-serif-editorial text-2xl mb-2">Pieza única</h3>
              <p className="text-[#5C5C5C] leading-relaxed">
                Series cortas. Lo que ves hoy puede no estar disponible mañana.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-10 py-20 text-center">
        <p className="font-serif-editorial italic text-3xl md:text-4xl leading-snug text-[#1E1E1E]">
          "No vendo objetos. Vendo tiempo, manos y una manera de mirar el mundo."
        </p>
        <Link to="/catalogo" className="btn-primary mt-10" data-testid="about-cta-catalog">
          Ver la colección
        </Link>
      </section>
    </div>
  );
}
